export const cardDelivery = {
    showAlertText: true,
    showNewDeliveryContact: false,
    useContacts: true,
};
